﻿
import { ref, type Ref } from 'vue';

interface ILoadingState {
    isLoading: Ref<boolean>;
    viewModelLoading: Ref<boolean>;
    errorLoading: Ref<boolean>;
    setError: () => void;
    startLoading: () => void;
    stopLoading: () => void;
    startViewModelLoading: () => void;
    stopViewModelLoading: () => void;
}

export class LoadingState implements ILoadingState {
    private readonly _isLoading: Ref<boolean>;
    private readonly _errorLoading: Ref<boolean>;
    private readonly _viewModelLoading: Ref<boolean>;

    constructor() {
        this._isLoading = ref<boolean>(false);
        this._errorLoading = ref<boolean>(false);
        this._viewModelLoading = ref<boolean>(true);
    }

    get isLoading(): Ref<boolean> {
        return this._isLoading;
    }

    get errorLoading(): Ref<boolean> {
        return this._errorLoading;
    }

    get viewModelLoading(): Ref<boolean> {
        return this._viewModelLoading;
    }

    public setError(): void {
        this._errorLoading.value = true;
        this._isLoading.value = false;
    }

    public startLoading(): void {
        this._isLoading.value = true;
        this._errorLoading.value = false;
    }

    public stopLoading(): void {
        this._isLoading.value = false;
    }

    public startViewModelLoading(): void {
        this._viewModelLoading.value = true;
        this._errorLoading.value = false;
    }

    public stopViewModelLoading(): void {
        this._viewModelLoading.value = false;
    }
}